export const WARRANTIES_TYPES = [
  {
    'key': 'TODOS',
    'text': 'TODOS',
    'value': 'TODOS',
  },
  {
    'key': 'VE',
    'text': 'VEHÍCULOS (VE)',
    'value': 'VE',
  },
  {
    'key': 'AC',
    'text': 'ACCESORIOS (AC)',
    'value': 'AC',
  },
  {
    'key': 'P1',
    'text': 'REPUESTOS (P1)',
    'value': 'P1',
  },
  {
    'key': 'P2',
    'text': 'REPUESTOS (P2)',
    'value': 'P2',
  },
  {
    'key': 'EX',
    'text': 'EXTENDIDAS (EX)',
    'value': 'EX',
  },
  {
    'key': 'CE',
    'text': 'CERTIFICADAS (CE)',
    'value': 'CE',
  },
];


export const WARRANTIES_TYPES_OBJECT = {
  'VE': 'VEHÍCULOS (VE)',
  'AC': 'ACCESORIOS (AC)',
  'P1': 'REPUESTOS (P1)',
  'P2': 'REPUESTOS (P2)',
  'EX': 'EXTENDIDAS (EX)',
  'CE': 'CERTIFICADAS (CE)',
};

export const warranties = {
  'hour_price': 25,
};
